import { select } from '@inv/utils/es/select'

export const DEFAULT_LOCALE = select({
  sg: 'en',
  ph: 'en',
  tw: 'zh-Hant',
  th: 'th-TH',
  vn: 'vi-VN',
  my: 'ms-MY',
  id: 'id-ID',
  default: 'en',
})
